// Deps
import { createComponent } from "react-fela";

// Components
import Blocks from "~/components/blocks";
import PostContent from "~/components/shared/post-content";
import { ContentMaxWidth } from "~/components/layout/max-width";

// Styles
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";

export default ({ page }) => {
    if (!page) return null;

    const { acf, title, content } = page;

    return (
        <div>
            {(!acf || !acf.modules) && (
                <PageWrapper>
                    <ContentMaxWidth>
                        {title && (
                            <Heading
                                dangerouslySetInnerHTML={{
                                    __html: title.rendered
                                }}
                            ></Heading>
                        )}

                        {content && <PostContent content={content.rendered} />}
                    </ContentMaxWidth>
                </PageWrapper>
            )}

            {acf && acf.modules && acf.modules.length && (
                <Blocks
                    blocks={acf.modules}
                    key={page.id}
                    prioritizeInitialBlocks
                    priorityCount={3}
                />
            )}
        </div>
    );
};

const PageWrapper = createComponent(() => ({
    extend: [
        fluid("paddingH", gutters.default),
        fluid("paddingV", gutters.vertical)
    ]
}));

const Heading = createComponent(
    () => ({
        ...textStyles.heading1,
        marginBottom: 40
    }),
    "h1",
    ["dangerouslySetInnerHTML"]
);
